
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateContainerDtoFormGroup() {
return new FormGroup({
    containertypeId: new FormControl<number | undefined>(undefined),
    contactId: new FormControl<number | undefined>(undefined),
    number: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
})
;
}
      